export default __webpack_public_path__ + "static/media/trade.a2c09083.png";